module.exports = __webpack_public_path__ + "img/germany-ovarian-cancer-female.3159842b.png";